export const checkDomain = () => {
  // если localhost - возвращает ''
  // если заканчивается на 'uz' - возвращает '.lambic.uz'
  // если сайт 'XX.keep-calm.XX' - возвращает '.lambic.keep-calm.ru'
  // в прочих случаях '.lambic.ru'

  switch (window.location.hostname.split('.').slice(-1)[0]) {
    case 'localhost':
      return '';
    case 'uz':
      return '.lambic.uz';
    default:
      return window.location.hostname.split('.').slice(-2)[0] === 'keep-calm' ? '.lambic.keep-calm.ru' : '.lambic.ru';
  }
};
